import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  DestinationActionsUnion,
  DestinationActionTypes
} from '@core/actions/destination.actions';
import { Destination } from '@app/models/destination';

export interface State extends EntityState<Destination> {
  loading: boolean;
  loaded: boolean;
}

export const adapter: EntityAdapter<Destination> = createEntityAdapter<
  Destination
>({
  selectId: (destination: Destination) => destination.id
});

export const INITIAL_STATE: State = adapter.getInitialState({
  loading: false,
  loaded: false
});

export function reducer(
  state: State = INITIAL_STATE,
  action: DestinationActionsUnion
) {
  switch (action.type) {
    case DestinationActionTypes.Load:
      return { ...state, loading: true };

    case DestinationActionTypes.LoadFail:
      return { ...state, loading: false };

    case DestinationActionTypes.LoadSuccess:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case DestinationActionTypes.Create:
      return { ...state, creating: true };

    case DestinationActionTypes.CreateFail:

    case DestinationActionTypes.CreateSuccess:
      return { ...state, creating: false };

    case DestinationActionTypes.AddAll:
      return adapter.addAll(action.destination, state);

    case DestinationActionTypes.AddOne:
      return adapter.addOne(action.destination, state);

    case DestinationActionTypes.RemoveOne:
      return adapter.removeOne(action.id, state);
    default:
      return state;
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal
} = adapter.getSelectors();

export const selectLoaded = (state: State) => state.loaded;
export const selectLoading = (state: State) => state.loading;

export const getState = createFeatureSelector<State>('destinations');

export const getAll = createSelector(
  getState,
  selectAll
);
